import { render } from "./OurTeams.vue?vue&type=template&id=bcfde352&scoped=true"
import script from "./OurTeams.vue?vue&type=script&lang=js"
export * from "./OurTeams.vue?vue&type=script&lang=js"

import "./OurTeams.vue?vue&type=style&index=0&id=bcfde352&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfde352"]])

export default __exports__